import { useState, useEffect } from 'react';
import api from '../../services/api';
import { useInternData } from '../../context/InternContext';import "../../assets/styles/Intern/TimelineSection.css";

function TimelineSection() {
  const { internData } = useInternData();
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getExperience().then((d) => {
      const items = Array.isArray(d) ? d : d?.timeline || d?.data || [];
      setTimeline(items);
      setLoading(false);
    }).catch(() => {setTimeline([]);setLoading(false);});
  }, []);

  // Group by year — safely guard against non-array
  const grouped = {};
  const safeTimeline = Array.isArray(timeline) ? timeline : [];
  safeTimeline.forEach((item) => {
    const yr = item.start_date ? new Date(item.start_date).getFullYear() : item.year || 'Other';
    if (!grouped[yr]) grouped[yr] = [];
    grouped[yr].push(item);
  });
  const years = Object.keys(grouped).sort((a, b) => b - a);

  const joinDate = internData.startDate ? new Date(internData.startDate) : null;
  const now = new Date();
  const months = joinDate ? Math.max(0, (now.getFullYear() - joinDate.getFullYear()) * 12 + (now.getMonth() - joinDate.getMonth())) : 0;

  return (
    <div>
      {/* Experience Summary */}
      <div className="card timelinesection-inline-1">
        <div className="timelinesection-inline-2">Internship Summary</div>
        <div className="timelinesection-inline-3">
          <div><span className="timelinesection-inline-4">Name:</span> <b>{internData.name || '—'}</b></div>
          <div><span className="timelinesection-inline-5">Role:</span> <b>{internData.role || '—'}</b></div>
          <div><span className="timelinesection-inline-6">Start Date:</span> <b>{internData.startDate ? new Date(internData.startDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</b></div>
          <div><span className="timelinesection-inline-7">Duration:</span> <b>{months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '—'}</b></div>
          <div><span className="timelinesection-inline-8">Team:</span> <b>{internData.team || '—'}</b></div>
          <div><span className="timelinesection-inline-9">Manager:</span> <b>{internData.manager || '—'}</b></div>
        </div>
      </div>

      {loading ? <div className="timelinesection-inline-10">Loading timeline...</div> :
      timeline.length === 0 ?
      <div className="card timelinesection-inline-11">No timeline events yet. Your activity history will appear here.</div> :
      years.map((yr) =>
      <div key={yr} className="timelinesection-inline-12">
          <div className="timelinesection-inline-13">{yr}</div>
          {grouped[yr].map((item, idx) =>
        <div key={idx} className="card timelinesection-inline-14">
              <div className="timelinesection-inline-15">{item.title || item.project_name || item.description || 'Activity'}</div>
              {item.role_in_project && <div className="timelinesection-inline-16">Role: {item.role_in_project}</div>}
              {item.start_date && <div className="timelinesection-inline-17">
                {new Date(item.start_date).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}
                {item.end_date ? ` — ${new Date(item.end_date).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}` : ' — Present'}
              </div>}
            </div>
        )}
        </div>
      )}
    </div>);

}

export default TimelineSection;